// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Cognito `UserStatus` of a user's identity, mirrored for display. Values
 * follow the Cognito API names one-to-one.
 */
export enum CognitoUserStatus {
  UNKNOWN = 0,
  UNCONFIRMED = 1,
  CONFIRMED = 2,
  ARCHIVED = 3,
  COMPROMISED = 4,
  RESET_REQUIRED = 5,
  FORCE_CHANGE_PASSWORD = 6,
  EXTERNAL_PROVIDER = 7,
}
